var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "add-new-card",
    attrs: {
      "bg-variant": _vm.variant
    }
  }, [_c('img', {
    staticClass: "d-flex m-auto h-100",
    attrs: {
      "src": require("@/assets/dashboard/plus.svg"),
      "alt": "Plus Icon",
      "width": "24px",
      "height": "24px"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }